<template>
    <div class="contest responsive-height">
        <v-container class="custom-container">
            <v-row dense>
                <v-col cols="12" class="px-6">
                    <join-request-tab></join-request-tab>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>

import JoinRequestTab from '@/components/Contest/JoinRequestTab.vue';
export default {
    components: { JoinRequestTab },
}
</script>
